import {PathProps} from "../shared";
import {AccountBoxOutlined, AirplayOutlined, ContentPasteOutlined, NotificationsOutlined} from "@mui/icons-material";
import {SvgIcon} from "@mui/material";
import {ReactElement} from "react";
import {PatientsApplet} from "./applets/patients/PatientsApplet";
import {CasesApplet} from "./applets/cases/CasesApplet";
import {OrdersApplet} from "./applets/orders/OrdersApplet";
import {NotificationsApplet} from "./applets/notifications/NotificationsApplet";

export type Applet = {
  id: string,
  name: string,
  iconType: typeof SvgIcon,
  render?: (pathProps: PathProps, ...args) => ReactElement,
}

export const APPLETS: Applet[] = [
  {
    id: "cases",
    name: "Cases",
    iconType: AirplayOutlined,
    render: (pathProps, args) => <CasesApplet path={pathProps}/>,
  },
  {
    id: "patients",
    name: "Patients",
    iconType: AccountBoxOutlined,
    render: (pathProps, args) => <PatientsApplet path={pathProps}/>,
  },
  {
    id: "orders",
    name: "Orders",
    iconType: ContentPasteOutlined,
    render: (pathProps, args) => <OrdersApplet path={pathProps}/>,
  },
  {
    id: "notifications",
    name: "Notifications",
    iconType: NotificationsOutlined,
    render: (pathProps, args) => <NotificationsApplet path={pathProps}/>,
  },
];